<div class="">
    <!-- Tabs Navigation -->
    <div class="bg-light shadow-sm banner-pills">
        <div class="d-flex justify-content-center bg-banner-gradient p-2">
          <ul class="pills-billing-tab nav nav-pills mx-auto" role="tablist">
            <li class="nav-item text-center" role="presentation">
              <button class="nav-link w-100 fs-xsm fw-500" :class="{ active: activeVoiceTab === 'discussions' }"
                @click="activeVoiceTab = 'discussions'">Discussions</button>
            </li>
            <li class="nav-item text-center" role="presentation">
              <button class="nav-link w-100 fs-xsm fw-500" :class="{ active: activeVoiceTab === 'surveys' }"
                @click="activeVoiceTab = 'surveys'">Surveys</button>
            </li>

            <li class="nav-item text-center" role="presentation">
              <button class="nav-link w-100 fs-xsm fw-500" :class="{ active: activeVoiceTab === 'polls' }"
                @click="activeVoiceTab = 'polls'">Polls</button>
            </li>
          </ul>
        </div>
      </div>
      
        

    <!-- Tab Content -->
    <div class="tab-content p-3 full-width-mobile padding-x">
        <div v-show="activeVoiceTab === 'discussions'">
            <Discussion/>
        </div>
        <!-- Survey Listing & Form View -->
        <div v-show="activeVoiceTab === 'surveys'">
            <div class="d-flex align-items-center mb-4">
                <button @click="showSurveyCreation = true; activeVoiceTab = 'questions'" 
                        class="btn btn-primary text-xxs rounded-3 shadow-sm">
                 + Create New Survey
                </button>
              </div>

            <!-- My Surveys Section - Only shown if user has surveys -->
  <!-- Survey Card 1 -->
   <div class="mb-4" v-if="surveys.filter(s => s.creater.id === Number(user_id)).length > 0">
       <div class="card mb-3 border-0 rounded-3 shadow-sm" v-for="survey in surveys.filter(s => s.creater.id === Number(user_id))" :key="survey.id">
                <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                    <h6 class="card-title mb-1">{{ survey.name }}</h6>
                    <p class="card-text text-muted text-xs mt-1">
                        {{ survey.description }}
                    </p>
                    </div>
                    <div class="dropdown">
                    <button class="btn btn-link text-muted" type="button" data-bs-toggle="dropdown">
                        <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item text-xxs fw-bold" @click.prevent="editSurvey(survey)">Edit</a></li>
                        <li><a class="dropdown-item text-xxs fw-bold" @click.prevent="deleteSurvey(survey.id)">Delete</a></li>
                    </ul>
                    </div>
                </div>

                <div class="d-flex  flex-wrap mt-3">
                    <div class="ms-auto">
                        <button class="btn btn-secondary btn-sm text-xs shadow-sm" :class="{ active: activeVoiceTab === 'responses' }"
                          @click="activeVoiceTab = 'responses'">Result</button>
                    </div>
                    
                </div>
                </div>
            </div>
   </div>
 
            </div>

        <!-- Other Surveys Section -->
        <div v-show="activeVoiceTab === 'surveys'">
            <div>
                <div v-for="survey in surveys.filter(s => s.creater.id !== Number(user_id))" :key="survey.id" class="card mb-3 border-0 rounded-3 shadow-sm">
                     <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                    <h6 class="card-title mb-1">{{ survey.name }}</h6>
                    <p class="card-text text-muted text-xs mt-1">
                        {{ survey.description }}
                    </p>
                    </div>
                </div>
                <div class="d-flex  flex-wrap mt-3">
                
                    <div class="ms-auto">
                        <button 
                            v-if="!survey.expired && !survey.is_answered" 
                            :class="[
                                'btn btn-sm text-xxs rounded-3',
                                selectedSurveyId === survey.id ? 'btn-danger' : 'btn-secondary'
                            ]"
                            @click="toggleSurvey(survey.id)"
                            >
                            {{ selectedSurveyId === survey.id ? 'Cancel' : 'Answer Survey' }}
                            </button>

                        <div v-if="survey.is_answered" class="mt-2">
                         <span class="badge bg-success text-white">Already Answered</span>
                      </div>
                    </div>
                    
                </div>
                </div>
                    <div v-show="selectedSurveyId === survey.id" class="">
                        <div v-for="(question, index) in survey.survey_questions" :key="question.id"
                            class="p-3">
                            <label class="text-xs">{{ index + 1 }}. {{ question.question.question }}</label>

                            <div v-if="question.question.question_type.question_type === 'yes_no'">
                                <div v-for="opt in ['Yes', 'No']" :key="opt" class="form-check">
                                    <input type="radio" class="form-check-input" :name="'q' + question.question.id" :value="opt"
                                        v-model="answers[question.question.id]">
                                    <label class="form-check-label">{{ opt }}</label>
                                </div>
                            </div>

                            <div v-else-if="question.question.question_type.question_type === 'multiple_choice'">
                                <div v-for="opt in question.question.options" :key="opt.id" class="form-check">
                                <input type="radio"
                                        class="form-check-input"
                                        :id="'q' + question.question.id + '-' + opt.id"
                                        :name="'q' + question.question.id"
                                        :value="opt.option"
                                        v-model="answers[question.question.id]">
                                <label class="form-check-label" :for="'q' + question.question.id + '-' + opt.id">{{ opt.option }}</label>
                                </div>
                            </div>

                                <select
                                v-else-if="question.question.question_type.question_type === 'selection'"
                                class="form-select text-xs rounded-5"
                                :id="'question_' + question.question.id"
                                v-model="answers[question.question.id]"
                                >
                                <option value="" disabled>Select an option</option>
                                <option
                                    v-for="option in question.question.options"
                                    :key="option.id"
                                    :value="option.option"
                                >
                                    {{ option.option }}
                                </option>
                            </select>
                            


                            <div v-else-if="question.question.question_type.question_type === 'checkbox'" class="form-check" >
                                <div v-for="option in question.question.options" :key="option.id" class="form-check">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        :id="'checkbox_' + option.id"
                                        :value="option.option"
                                        @change="toggleCheckboxAnswer(survey,question.question.id, option.option, $event.target.checked)"
                                    />
                                    <label class="form-check-label" :for="'checkbox_' + option.id">
                                        {{ option.option }}
                                    </label>
                                    </div>
                                </div>

                            <!-- Text Input -->
                            <input
                                v-if="question.question.question_type.question_type === 'text'"
                                type="text"
                                class="form-control text-xxs rounded-5"
                                :id="'question_' + question.question.id"
                                :placeholder="question.question.question"
                                v-model="answers[question.question.id]"
                                />

                            <input
                                v-else-if="question.question.question_type.question_type === 'number'"
                                type="number"
                                class="form-control text-xs rounded-5 w-25 rounded-5"
                                :id="'question_' + question.question.id"
                                v-model="answers[question.question.id]"
                                :placeholder="question.question.question"
                                />

                            <input
                                v-else-if="question.question.question_type.question_type === 'date'"
                                type="date"
                                class="form-control text-xs rounded-5 w-25 rounded-5"
                                :id="'question_' + question.question.id"
                                v-model="answers[question.question.id]"
                                />

                            <input
                                v-else-if="question.question.question_type.question_type === 'file'"
                                type="file"
                                class="form-control text-xs rounded-5 w-25"
                                :id="'question_' + question.question.id"
                                @change="handleFileUpload($event, question)"
                                />
                        </div>

                        <div class="d-flex justify-content-end p-2">
                            <button class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm" @click="submitSurveyAnswers(survey)" >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Survey Form Tab -->
        <div v-show="activeVoiceTab === 'questions'" >
            <!-- <div class="container py-0"> -->
                <!-- <div class="scroll-container bg-light p-3 rounded-4 py-0"> -->
                    <div class="bg-white p-3 rounded-3 shadow-sm">
                        <form @submit.prevent="submitSurvey()">
                            <!-- Survey Title -->
                            <div class="mb-3">
                                <label for="survey_name" class="form-label text-xs fw-500">Survey Name<span class="text-danger">*</span></label>
                                <input type="text" class="form-control rounded-5 text-xs" id="survey_name" placeholder="Enter survey name" v-model="survey_name">
                                <p v-if="errors.survey_name" class="text-danger text-xs mt-1">{{ errors.survey_name }}</p>
                            </div>

                            <!-- Survey Description -->
                            <div class="mb-3">
                                <label for="survey_description" class="form-label text-xs fw-500">Survey Description</label>
                                <QuillEditor theme="snow" v-model="survey_description" ref="quillSurveyEditorRef" class="quill-editor" placeholder="Enter your description here..." toolbar="half" />
                            </div>
                            <div class="mb-3 p-2">
                                 <button 
                                    type="button" 
                                    class="text-primary bg-transparent fw-bold border-0 float-end text-xs rounded-5 mb-3" 
                                    @click="showQuestionForm = !showQuestionForm">
                                    <i class="bi bi-plus-lg me-1"></i>
                                    {{ showQuestionForm ? 'Hide Question Form' : 'Add Question' }}
                                </button>
                            <div v-if="showQuestionForm">

                                <div class="row mt-2 w-100 ">
                                    <!-- Question Input -->
                                    <div class="form-group col-sm-6 mb-1 my-3">
                                        <label class="text-xs">Question<span class="text-danger">*</span></label>
                                        <div class="d-flex">
                                            <input
                                                type="text"
                                                class="form-control text-xxs rounded-5 p-2 bg-white"
                                                v-model="newQuestion.text"
                                                placeholder="Enter question text"
                                                list="questionSuggestions"
                                                @input="onQuestionInput"
                                                @change="onQuestionSelect"
                                            />
                                        </div>
                                        <datalist id="questionSuggestions">
                                            <option v-for="question in filteredQuestions" :key="question.id" :value="question.question"></option>
                                        </datalist>
                                    </div>
                                
                                    <!-- Question Number Input -->
                                    <div class="form-group col-sm-6 mb-1 my-3">
                                        <label class="text-xs">Question Number<span class="text-danger">*</span></label>
                                        <input type="text"
                                               class="form-control text-xxs rounded-5 p-2 bg-white"
                                               placeholder="Eg. 1"
                                               v-model="newQuestion.question_number" />
                                    </div>
                                
                                    <!-- Question Type Select -->
                                    <div class="form-group col-sm-6 mb-1 my-3">
                                        <label class="text-xs">Type</label>
                                        <select v-model="newQuestion.type"
                                                class="form-select text-xxs p-2 rounded-5">
                                            <option value="" disabled>Select</option>
                                            <option v-for="type in question_types"
                                                    :key="type.id"
                                                    :value="type.id">
                                                {{ type.question_type }}
                                            </option>
                                        </select>
                                
                                        <!-- Options Input for Multiple Choice, Checkbox, or Selection -->
                                        <div v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)"
                                            v-for="(option, index) in newQuestion.options"
                                            :key="option.id || index"
                                            class="d-flex align-items-center mb-2">
                                        <input type="text"
                                                class="form-control text-xxs rounded-5 p-2 me-2"
                                                v-model="option.text"
                                                placeholder="Enter option text" />
                                            <button class="btn btn-danger btn-sm text-xs"
                                                    type="button"
                                                    @click="removeOption(index)">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        </div>
                                
                                        <div v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)">
                                            <button class="btn btn-sm btn-warning text-white mt-3 text-xxs rounded-3 shadow-sm fw-500" type="button"
                                                    @click="addOption">
                                                 Add Option
                                            </button>
                                        </div>
                                    </div>
                                
                                    <!-- Is Mandatory Select -->
                                    <div class="form-group col-sm-6 mb-1 my-3">
                                        <label class="text-xs">Is the question mandatory?</label>
                                        <select v-model="newQuestion.is_mandatory"
                                                class="form-select text-xxs p-2 rounded-5">
                                            <option :value="true">Yes</option>
                                            <option :value="false">No</option>
                                        </select>
                                    </div>

                                    <!-- Add Question Button -->
                                    <div class="col-12 mt-3">
                                        <button 
                                            type="button" 
                                            class="btn btn-sm btn-success text-xxs rounded-3 float-end"
                                            @click="addQuestionToSurvey"
                                            :disabled="!newQuestion.text || !newQuestion.type || !newQuestion.question_number"
                                        >
                                            Add Question to Survey
                                        </button>
                                    </div>
                                </div>
                                <div class="mt-3" v-if="createdQuestions.length > 0">
                                    <h6 class="text-xs fw-bold">Created Questions</h6>
                                    <!-- <ul>
                                        <li > -->
                                            <div v-for="(question, index) in createdQuestions" :key="index" class="d-flex justify-content-between align-items-center border rounded p-2 text-xs mb-2">
                                            <div>
                                                <span class="fw-bold">{{ index + 1 }}. {{ question.text }}</span>
                                                <span class="badge bg-secondary ms-2 text-xxs">
                                                    {{ question.type ? (question_types.find(t => t.id === question.type)?.question_type || 'Unknown') : 'Unknown' }}
                                                </span>
                                                <span v-if="question.is_mandatory" class="badge bg-danger ms-1 text-xxs">Required</span>
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn-sm text-danger"
                                                @click="removeCreatedQuestion(index)"
                                                title="Remove"
                                            >
                                                <i class="bi bi-trash text-danger"></i>
                                            </button>
                                        </div>
                                        <!-- </li>
                                    </ul> -->
                                </div>
                                 <div class="d-flex justify-content-end" v-if="createdQuestions.length > 0">
                                    <button type="submit" class="btn btn-sm btn-primary text-xxs rounded-3">
                                        {{ survey_id ? 'Update' : 'Create' }} Survey
                                    </button>
                                    <button v-if="survey_id" type="button" class="btn btn-sm btn-danger text-xxs rounded-3 ms-2" @click="cancelEdit">
                                        Cancel
                                    </button>
                             </div>
                              </div>
                             
                            </div>

                            <!-- Submit -->
                            
                        </form>
                    </div>
                <!-- </div> -->
            <!-- </div> -->
        </div>

        <!-- Responses Tab -->
        <div v-show="activeVoiceTab === 'responses'">
            <div v-if="surveys.filter(s => s.creater.id === Number(user_id)).length === 0" class="text-center text-muted my-4">
                No survey responses available
            </div>
            <div v-for="survey in surveys.filter(s => s.creater.id === Number(user_id))"
                :key="survey.id" class="card bg-white p-4 rounded-3 shadow-sm mb-3 border-0">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h6 class="card-title">{{ survey.name }}</h6>
                        <!-- <small v-if="showResponsesFor !== survey.id">{{ survey.description }}</small> -->
                    </div>
        
                    <div class="d-flex align-items-center">
                        <!-- <button class="btn btn-primary btn-sm rounded-5 text-xs"
                                @click="toggleSurveyResponses(survey.id)">
                            {{ showResponsesFor === survey.id ? 'Hide Responses' : 'Responses' }}
                        </button> -->
                    </div>
                </div>
        
                <div class="border-top pt-2">
                    <div v-for="(question, index) in survey.survey_questions" :key="question.id"
                        class="mb-3 p-2 bg-light rounded border">
                        <div class="d-flex justify-content-between align-items-center text-xs">
                            <p class="fw-bold mb-0">{{ index + 1 }}. {{ question.question.question }}</p>
                            <a class="btn text-secondary text-xs fw-bold" @click="toggleQuestionResponses(question.id)">
                                Responses ({{ question.answers?.length || 0 }}) 
                                <span v-if="expandedQuestions.get(question.id)">▲</span>
                                <span v-else>▼</span>
                        </a>
                        </div>
        
                        <ul class="list-group list-group-flush mt-2" v-show="expandedQuestions.get(question.id)">
                            <li v-for="(response, response_id) in question.answers"
                                :key="response_id"
                                class="list-group-item py-1 px-2 small text-muted">
                                <i class="bi bi-dot text-secondary me-1"></i>
                                <strong>{{ response.user?.first_name }} {{ response.user?.last_name }}</strong>:
                                {{ response.answer || '—' }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

        <div class="tab-content p-2">
        <!-- Poll Listing & Form View -->
        <div v-show="activeVoiceTab === 'polls'">
            <div class="mb-3">
                <button @click="showPollCreation = true; activeVoiceTab = 'questionpoll'" 
                        class="btn btn-sm btn-primary text-xxs rounded-3">
                  + Create New Poll
                </button>
              </div>

            <!-- My Polls Section - Only shown if user has polls -->
             <div class="mb-4" v-if="polls.filter(s => s.creater.id === Number(user_id)).length > 0">
                <div v-for="poll in polls.filter(s => s.creater.id === Number(user_id))" :key="poll.id" class="card bg-white px-4 py-2 rounded-3 shadow-sm mb-3 border-0">
                    <fieldset class="border border-secondary rounded-3 p-3 position-relative mt-4 overflow-visible">
                                <legend class="position-absolute top-0 start-0 translate-middle-y bg-white px-2 ms-3 fs-6 text-muted">{{ poll.name }}</legend>
                        <div class="d-flex justify-content-between align-items-start">
                            <div>
                                <div v-for="question in poll.poll_questions" class="text-xs">
                                
                                    <p>{{ question.question.question }}</p>
                                    <div v-if="question.question.question_type.question_type === 'checkbox'">
                                        <div class="form-check" v-for="option in question.question.options" :key="option.id">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            :id="'checkbox_' + option.id"
                                            :value="option.option"
                                            @change="toggleCheckboxAnswerP(poll,question.question.id, option.option, $event.target.checked)"
                                        />
                                        <label class="form-check-label" :for="'checkbox_' + option.id">
                                            {{ option.option }}
                                        </label>
                                        </div>
                                    </div>
                                    <div v-else>
                                    <div class="form-check" v-for="option in question.question.options" :key="option.id">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="'radio_' + option.id"
                                            :name="'question_' + question.question.id"
                                            :value="option.option"
                                            v-model="answers[question.question.id]"
                                        />
                                        <label class="form-check-label" :for="'radio_' + option.id">
                                            {{ option.option }}
                                        </label>
                                        </div>
                                </div>                            
                                </div>
                            </div>

                            <div class="d-flex align-items-center">
                                <div class="dropstart" @click.stop>
                                    <a href="" class="fw-bold text-dark" id="pollDropdownMenu" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="bi bi-three-dots-vertical"></i><span class="small"></span>
                                    </a>
                                    <ul class="dropdown-menu custom-dropdown" aria-labelledby="pollDropdownMenu">
                                        <li>
                                            <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="editPoll(poll)">
                                                <i class="bx bxs-edit fs-6"></i> Edit Poll
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="deletePoll(poll.id)">
                                                <i class='bx bxs-trash-alt fs-6'></i> Delete
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div class="d-flex justify-content-end mt-2">
                       <button class="btn btn-primary btn-sm text-xxs" @click="openPollResponses(poll)">Poll Responses</button>
                    </div>
                    
                </div>
            </div>
            
            </div>

        <!-- Other Polls Section -->
        <div v-show="activeVoiceTab === 'polls'">
            <div>
                <div v-for="poll in polls.filter(s => s.creater.id !== Number(user_id))" :key="poll.id" class="card bg-white p-2 rounded-3 shadow-sm mb-3 border-0">
                    <fieldset class="border border-secondary rounded-3 p-2 position-relative mt-4 overflow-visible">
                        <legend class="position-absolute top-0 start-0 translate-middle-y bg-white px-2 ms-3 fs-6 text-muted">{{ poll.name }}  <span v-if="poll.is_answered" class="badge bg-success text-white text-xxs fw-normal">Already Answered</span></legend>

                    <div>
                        <div v-for="(question, index) in poll.poll_questions" :key="question.id" class="mb-3 p-3">
                            <p class="text-xs">{{ index + 1 }}. {{ question.question.question }}</p>

                                <div v-if="question.question.question_type.question_type === 'selection'"
                                    :id="'question_' + question.question.id"
                                    class="d-flex flex-column gap-2"
                                    >
                                    <div
                                        v-for="option in question.question.options"
                                        :key="option.id"
                                        class="form-check"
                                    >
                                        <input
                                        class="form-check-input text-xs"
                                        type="checkbox"
                                        :name="'question_' + question.question.id"
                                        :id="'option_' + option.id"
                                        :value="option.option"
                                        v-model="answers[question.question.id]"
                                        />
                                        <label class="form-check-label text-xs" :for="'option_' + option.id">
                                        {{ option.option }}
                                        </label>
                                    </div>
                                  </div>

                                  <div v-else-if="question.question.question_type.question_type === 'checkbox'" class="form-check" >
                                <div v-for="option in question.question.options" :key="option.id" class="form-check">
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        :id="'checkbox_' + option.id"
                                        :value="option.option"
                                        @change="toggleCheckboxAnswerP(poll,question.question.id, option.option, $event.target.checked)"
                                    />
                                    <label class="form-check-label" :for="'checkbox_' + option.id">
                                        {{ option.option }}
                                    </label>
                                    </div>
                                </div>

                        </div>
                    </div>
                </fieldset>
                 <div class="d-flex justify-content-end mt-2">
                            <button class="btn btn-primary btn-sm text-xxs rounded-3" @click="submitPollAnswers(poll)" >
                                Submit
                            </button>
                        </div>
                </div>
            </div>
        </div>

        <!-- poll Form Tab -->
        <div v-if="activeVoiceTab === 'questionpoll'">
                    <div class="bg-white px-3 py-3">
                        <form @submit.prevent="submitPollForm()">
                            <div class="mb-3"></div>
                                <input
                                type="text"
                                class="form-control form-control-lg border-0"
                                id="poll_name"
                                placeholder="Poll Name"
                                v-model="poll_name"/>
                                <p v-if="errors.poll_name" class="text-danger text-xs mt-1">
                                    {{ errors.poll_name }}
                                </p>
                                <input type="text" class="form-control form-control-lg border-0" placeholder="What is your question?" v-model="poll_question"/>
                                <p v-if="errors.poll_question" class="text-danger text-xs mt-1">
                                    {{ errors.poll_question }}
                                </p>
                                 <div v-for="(option, index) in options" :key="index" class="poll-option mb-2">
                                    <div class="input-group">
                                        <span class="input-group-text text-xs border-0 bg-transparent">
                                        <i v-if="!option.value" class="bi bi-plus-circle mt-1"></i>
                                        <input
                                            v-else
                                            :type="allowMultiple ? 'checkbox' : 'radio'"
                                            class="form-check-input mt-0"
                                            :name="'poll-radio'"
                                            disabled
                                        />
                                        </span>
                                        <input
                                        type="text"
                                        class="form-control form-control-sm border-0"
                                        :placeholder="`Answer ${index + 1}`"
                                        v-model="option.value"
                                        @input="on_input(index)"
                                        />
                                        <p v-if="errors.poll_answer" class="text-danger text-xs mt-1">
                                            {{ errors.poll_answer }}
                                        </p>
                                    </div>
                                    </div>
                            <div class="d-flex justify-content-end">
                                <button type="submit" class="btn btn-primary btn-sm text-xxs rounded-3">
                                    {{ poll_id ? 'Update' : 'Create' }} Poll
                                </button>
                                <button v-if="poll_id" type="button" class="btn btn-sm btn-danger text-xxs rounded-3 ms-2" @click="cancelEditPoll">
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
        </div>

        <!-- Poll Responses Tab -->
        <div v-show="activeVoiceTab === 'pollresponses'">
       
            <div v-for="poll in polls" :key="poll.id" class="card bg-white p-4 rounded-5 shadow-sm mb-3 border-0">
                <fieldset class="border border-secondary rounded-3 p-2 position-relative mt-4 overflow-visible">
                        <legend class="position-absolute top-0 start-0 translate-middle-y bg-white px-2 ms-3 fs-6 text-muted">{{ poll.name }}</legend>
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h6 class="card-title">{{ poll.name }}</h6>
                        <small v-if="showResponsesFor !== poll.id">{{ poll.description }}</small>
                    </div>
        
                    <div class="d-flex align-items-center">
                        <button class="btn btn-primary btn-sm rounded-5 text-xs"
                                @click="togglePollResponses(poll.id)">
                            {{ showResponsesFor === poll.id ? 'Hide Responses' : 'Responses' }}
                        </button>
                    </div>
                </div>
              </fieldset>
        
                <div v-show="showResponsesFor === poll.id" class="mt-4 border-top pt-4">
                    <div v-for="(question, index) in poll.poll_questions" :key="question.id"

                        class="mb-3 p-3 bg-light rounded border">
                        <p>{{question}}</p>
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="fw-bold mb-0">{{ index + 1 }}. {{ question.question.question }}</p>
                            <a class="btn text-secondary text-xs fw-bold" @click="toggleQuestionResponses(question.id)">
                                Votes ({{ question.answers?.length || 0 }}) 
                                <span v-if="expandedQuestions.get(question.id)">▲</span>
                                <span v-else>▼</span>
                        </a>
                        </div>
        
                            <ul class="list-group list-group-flush mt-2" v-show="expandedQuestions.get(question.id)">                            <li v-for="(response, response_id) in question.answers"
                                :key="response_id"
                                class="list-group-item py-1 px-2 small text-muted">
                                <i class="bi bi-dot text-secondary me-1"></i>
                                <strong>{{ response.user?.first_name }} {{ response.user?.last_name }}</strong>:
                                {{ response.answer || '—' }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="pollResponsesModal" tabindex="-1" aria-labelledby="pollResponsesLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="pollResponsesLabel">{{ selectedPoll?.name }} - Responses</h5>
           <button class="btn btn-sm btn-primary text-xxs rounded-3 me-2" @click="download_pdf">
            Export to PDF
            </button>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" v-if="selectedPoll" ref="pdf_content">
        <div v-for="question in selectedPoll.poll_questions" :key="question.id" class="mb-3">
          <p class="fw-bold">{{ question.question.question }}</p>
          <div v-for="option in question.question.options" :key="option.id" class="ms-3">
            <p class="mb-1">{{ option.option }}</p>
            <ul class="ps-4">
              <li v-for="answer in question.answers.filter(a => a.answer.includes(option.option))" :key="answer.id">
                {{ answer.user.first_name }} {{ answer.user.last_name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
